<template>

   <v-app>

    <v-dialog name="editRow" v-model="level.dialogValues.dialogShow" data-app="true" persistent max-width="900">

      <v-card>

         <b-tabs>

            <b-tab id="chapter1" active>

               <template slot="title">
                  <big><i class="icon-list"></i> {{ $t('titles.synthesis') }}</big>
               </template>

               <CardUpdatableHeader :row="row" :level="level"/>

               <v-card-text>

                  <v-form v-model="isFormValid">

                  <v-container>

                     <ddoAlert :errors="level.infos"/>

                     <h3>{{ $t('subtitles.properties') }}</h3>

                     <v-row>
                     <v-col cols="12" sm="6">
                        <v-text-field
                           v-model="row.cus_name" 
                           outlined 
                           filled
                           :label="$t('texts.cus_name')" 
                           :hint="$t('hints.cus_name')"
                           :disabled="level.dialogValues.form_disabled" 
                           :rules="level.dialogOptions.codeRules" 
                           persistent-hint
                           @input="check_code"
                        >
                        </v-text-field>
                     </v-col>
                     <v-col cols="12" sm="6">
                        <v-text-field
                           v-model="row.cus_code" 
                           :label="$t('texts.cus_code')" 
                           :readonly="cus_code_readonly" 
                           :hint="level.dialogValues.form_create==true ? $t('hints.cus_code_create') : $t('hints.cus_code_update')" 
                           filled
                           persistent-hint
                           name="cus_code"
                           @keyup="uppercase_cus_code"
                           v-on:keypress="only_ASCII($event)"
                        >
                           <template v-slot:append>
                              <v-icon @click="change_edit" :disabled="level.dialogValues.form_disabled" v-if="level.dialogValues.form_create && cus_code_min_length">{{ v_icon_code(cus_code_readonly) }}</v-icon>
                           </template>

                        </v-text-field>
                     </v-col>
                     </v-row>

                     <v-row>
                        <v-col cols="12" sm="6">
                           <b-checkbox :disabled="level.dialogValues.form_disabled" v-model="row.cus_active">{{ $t('texts.cus_active') }}</b-checkbox><br/>
                           <b-checkbox :disabled="level.dialogValues.form_disabled" v-model="row.cus_blocked">{{ $t('texts.cus_blocked') }}</b-checkbox><br/>
                        </v-col>
                        <v-col cols="12" sm="6">
                           <ddoSelect2
                              :callbacks="CUTcallbacks"
                              ref="mySelectCUT"
                              filled
                              :disabled="level.dialogValues.form_disabled" 
                              :options="CUToptions"
                           >
                              <template v-slot:selection="data">
                                 <v-chip
                                    v-bind="data.attrs"
                                    :input-value="data.selected"
                                    close
                                 >
                                    <span>{{data.item.cut_name}}</span>
                                 </v-chip>
                              </template>

                              <template v-slot:item="data">
                                 <v-list-item-content>
                                    <v-list-item-title>{{data.item.cut_name}}</v-list-item-title>
                                 </v-list-item-content>
                              </template>
                           </ddoSelect2>
                           <template v-if="reseller_is_available==true">
                              <ddoSelect2
                                 :callbacks="CUSREScallbacks"
                                 ref="mySelectCUSRES"
                                 filled
                                 :disabled="level.dialogValues.form_disabled" 
                                 :options="CUSRESoptions"
                              >
                                 <template v-slot:selection="data">
                                    <v-chip
                                       v-bind="data.attrs"
                                       :input-value="data.selected"
                                       close
                                    >
                                       <span>{{data.item.cus_name}}</span>
                                    </v-chip>
                                 </template>

                                 <template v-slot:item="data">
                                    <v-list-item-content>
                                       <v-list-item-title>{{data.item.cus_name}}</v-list-item-title>
                                    </v-list-item-content>
                                 </template>
                              </ddoSelect2>
                              <template v-if="row.cus_pk_customer!=null">
                                 <b-checkbox :disabled="level.dialogValues.form_disabled" v-model="row.cus_invoice_default_reseller">{{ $t('texts.cus_invoice_default_reseller') }}</b-checkbox>
                              </template>
                           </template>
                        </v-col>
                     </v-row>

                     <v-row>
                        <v-col cols="12" sm="6">
                           <v-text-field v-model="row.cus_siret" filled :disabled="level.dialogValues.form_disabled" :label="$t('texts.cus_siret')" :hint="$t('hints.cus_siret')">
                           </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                           <v-text-field v-model="row.cus_vatnumber" filled :disabled="level.dialogValues.form_disabled" :label="$t('texts.cus_vatnumber')" :hint="$t('hints.cus_vatnumber')"></v-text-field>
                        </v-col>
                     </v-row>

                     <v-row>
                        <v-col cols="6" sm="6">
                           <v-text-field v-model="row.cus_main_domain" filled :disabled="level.dialogValues.form_disabled" :label="$t('texts.cus_main_domain')" :hint="$t('hints.cus_domain')">
                           </v-text-field>
                        </v-col>
                     </v-row>

                     <h3>{{ $t('subtitles.properties_bm') }}</h3>

                     <v-row dense v-if="!level.dialogValues.form_create">
                        <v-col cols="12" sm="6">
                           <v-text-field v-model="row.cus_quadratuscode" disabled :label="$t('texts.cus_quadratuscode')">
                           </v-text-field>
                           <v-text-field v-model="row.cus_bm_billing_id_text" disabled :label="$t('texts.cus_bm_billing_id')">
                           </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                           <v-text-field v-model="row.cus_bm_id_text" disabled :label="$t('texts.cus_bm_id')">
                           </v-text-field>
                           <v-text-field v-model="row.cus_bm_shipping_id_text" disabled :label="$t('texts.cus_bm_shipping_id')">
                           </v-text-field>
                           <v-text-field v-model="row.cus_bm_ddoemail_id_text" disabled :label="$t('texts.cus_bm_ddoemail_id')">
                           </v-text-field>
                        </v-col>
                     </v-row>

                     <h3>{{ $t('subtitles.properties_glpi') }}</h3>

                     <v-row dense v-if="!level.dialogValues.form_create">
                        <v-col cols="12" sm="6">
                           <v-text-field v-model="row.cus_glpi_id" disabled :label="$t('texts.cus_glpi_id')">
                           </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                           <v-text-field v-model="row.cus_main_domain" disabled :label="$t('texts.cus_main_domain')">
                           </v-text-field>
                        </v-col>
                     </v-row>

                     <h3>{{ $t('subtitles.properties_smtppro') }}</h3>

                     <v-row dense v-if="!level.dialogValues.form_create">
                        <v-col cols="12" sm="6">
                           <v-checkbox v-model="row.cus_can_change_dkim_selector" dense hide-details :label="$t('texts.cus_can_change_dkim_selector')" :disabled="level.dialogValues.form_delete"></v-checkbox>
                        </v-col>
                     </v-row>

                     <template v-if="level.dialogValues.form_create">
                        <v-row dense>
                           <b-checkbox size="lg" v-model="contactShow">{{ $t('texts.ctc_create_contact') }}</b-checkbox>
                        </v-row>
                        <template v-if="contactShow">
                           <h3>{{ $t('subtitles.contact_general') }}</h3>
                           <v-row dense>
                              <h4>{{ $t('subtitles.properties') }}</h4>
                              <v-col cols="12">
                                 <v-text-field
                                    v-model="row.ctc_email"
                                    :disabled="level.dialogValues.form_disabled" 
                                    :label="$t('texts._email')"
                                    :hint="$t('hints._email')"
                                    :rules="level.dialogOptions.emailRules"
                                    filled
                                 ></v-text-field>
                              </v-col>
                           </v-row>

                           <v-row dense>
                              <v-col cols="12" sm="6">
                                 <v-text-field v-model="row.ctc_firstname" filled :disabled="level.dialogValues.form_disabled" :label="$t('texts._firstname')">
                                 </v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6">
                                 <v-text-field v-model="row.ctc_lastname" filled :disabled="level.dialogValues.form_disabled" :label="$t('texts._lastname')"></v-text-field>
                              </v-col>
                           </v-row>

                           <v-row dense>
                              <v-col cols="12" sm="6">
                                 <v-text-field
                                 v-model="row.ctc_organizationname"
                                 :disabled="level.dialogValues.form_disabled" 
                                 :label="$t('texts.ctc_organizationname')"
                                 ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6">
                                 <ddoSelect2
                                    :callbacks="CTTcallbacks"
                                    ref="mySelectCTT"
                                    :options="CTToptions"
                                 >
                                    <template v-slot:selection="data">
                                       <v-chip
                                          v-bind="data.attrs"
                                          :input-value="data.selected"
                                          close
                                          @click:close="$refs.mySelectCTT.remove(data.item)"
                                       >
                                          <span>{{data.item.ctt_name}}</span>
                                       </v-chip>
                                    </template>

                                    <template v-slot:item="data">
                                       <v-list-item-content>
                                          <v-list-item-title>{{data.item.ctt_name}}</v-list-item-title>
                                       </v-list-item-content>
                                    </template>
                                 </ddoSelect2>
                              </v-col>
                           </v-row>

                           <v-row>
                              <v-col cols="12" sm="6">
                                 <h4>{{ $t('subtitles.postal_address') }}</h4>
                                 <v-text-field
                                    v-model="row.ctc_addr_line1"
                                    :disabled="level.dialogValues.form_disabled" 
                                    :label="$t('texts.ctc_addr_line1')"
                                 ></v-text-field>
                                 <v-text-field
                                    v-model="row.ctc_addr_line2"
                                    :disabled="level.dialogValues.form_disabled" 
                                    :label="$t('texts.ctc_addr_line2')"
                                 ></v-text-field>
                                 <v-text-field
                                    v-model="row.ctc_addr_zipcode"
                                    :disabled="level.dialogValues.form_disabled" 
                                    :label="$t('texts.ctc_addr_zipcode')"
                                 ></v-text-field>
                                 <v-text-field
                                    v-model="row.ctc_addr_city"
                                    :disabled="level.dialogValues.form_disabled" 
                                    :label="$t('texts.ctc_addr_city')"
                                 ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6">
                                 <h4>{{ $t('subtitles.phones') }}</h4>
                                 <h5>{{ $t('subtitles.phone_fixed') }}</h5>
                                 <VuePhoneNumberInput
                                    v-model="row.ctc_phones.ctc_phone_fixed_phone.nationalNumber"
                                    :default-country-code="row.ctc_phones.ctc_phone_fixed_phone.country"
                                    :label="$t('texts.ctc_phone_fixed_phone')"
                                    :translations="translations"
                                    :disabled="level.dialogValues.form_disabled"
                                    @update="phone_update_fixed"
                                 />
                                 <h5>{{ $t('subtitles.phone_cell') }}</h5>
                                 <VuePhoneNumberInput
                                    v-model="row.ctc_phones.ctc_phone_cell_phone.nationalNumber"
                                    :default-country-code="row.ctc_phones.ctc_phone_cell_phone.country"
                                    :label="$t('texts.ctc_phone_cell_phone')"
                                    :translations="translations"
                                    :disabled="level.dialogValues.form_disabled"
                                    @update="phone_update_cell"
                                 />
                              </v-col>
                           </v-row>
                           <v-row dense>
                              <v-col cols="12" sm="6">
                                 <b-checkbox size="lg" v-model="row.ctc_is_invoicing">{{ $t('texts.ctc_is_invoicing') }}</b-checkbox><br/>
                                 <b-checkbox size="lg" v-model="row.ctc_is_shipping">{{ $t('texts.ctc_is_shipping') }}</b-checkbox>
                              </v-col>
                           </v-row>
                        </template>
                     </template>

                     <template v-if="!level.dialogValues.form_create">
                        <h3>{{ $t('subtitles.contacts') }}</h3>

                        <v-btn small class="primary" :disabled="level.dialogValues.form_disabled" rounded @click="load_for_create()">{{ $t('buttons.create_contact') }}</v-btn>

                        <v-row dense>
                           <v-col cols="6" sm="6">
                              <ddoSelect2
                                 :callbacks="CTCcallbacks_general"
                                 :key="CTCoptions_general.key"
                                 :options="CTCoptions_general"
                                 :disabled="level.dialogValues.form_disabled" 
                                 ref="mySelectCTCgeneral"
                              >
                                 <template v-slot:selection="data">
                                    <v-chip
                                       v-bind="data.attrs"
                                       :input-value="data.selected"
                                       close
                                       @click:close="$refs.mySelectCTCgeneral.remove(data.item)"
                                    >
                                       <span>{{data.item.ctc_email}} ({{data.item.ctc_firstname}} {{data.item.ctc_lastname}})</span>
                                    </v-chip>
                                 </template>

                                 <template v-slot:item="data">
                                    <v-list-item-content>
                                       <v-list-item-title>{{data.item.ctc_email}} ({{data.item.ctc_firstname}} {{data.item.ctc_lastname}})</v-list-item-title>
                                    </v-list-item-content>
                                 </template>
                              </ddoSelect2>
                           </v-col>
                           <v-col cols="6" sm="6">
                              <v-btn small class="error"  :disabled="level.dialogValues.form_disabled || row.ctc_pk_general==null" rounded @click="load_for_select(row.ctc_pk_general)">{{ $t('buttons.display') }}</v-btn>
                              <v-btn small class="error"  :disabled="level.dialogValues.form_disabled || row.ctc_pk_general==null" rounded @click="load_for_update(row.ctc_pk_general)">{{ $t('buttons.modify') }}</v-btn>
                              <v-btn small class="error"  :disabled="level.dialogValues.form_disabled || row.ctc_pk_general==null" rounded @click="load_for_delete(row.ctc_pk_general)">{{ $t('buttons.delete') }}</v-btn>
                           </v-col>
                        </v-row>
                        <v-row dense>
                           <v-col cols="6" sm="6">
                              <ddoSelect2
                                 :callbacks="CTCcallbacks_invoicing"
                                 :key="CTCoptions_invoicing.key"
                                 :options="CTCoptions_invoicing"
                                 :disabled="level.dialogValues.form_disabled" 
                                 ref="mySelectCTCinvoicing"
                              >
                                 <template v-slot:selection="data">
                                    <v-chip
                                       v-bind="data.attrs"
                                       :input-value="data.selected"
                                       close
                                       @click:close="$refs.mySelectCTCinvoicing.remove(data.item)"
                                    >
                                       <span>{{data.item.ctc_email}} ({{data.item.ctc_firstname}} {{data.item.ctc_lastname}})</span>
                                    </v-chip>
                                 </template>

                                 <template v-slot:item="data">
                                    <v-list-item-content>
                                       <v-list-item-title>{{data.item.ctc_email}} ({{data.item.ctc_firstname}} {{data.item.ctc_lastname}})</v-list-item-title>
                                    </v-list-item-content>
                                 </template>
                              </ddoSelect2>
                           </v-col>
                           <v-col cols="6" sm="6">
                              <v-btn small class="error" :disabled="level.dialogValues.form_disabled || row.ctc_pk_invoicing==null" rounded @click="load_for_select(row.ctc_pk_invoicing)">{{ $t('buttons.display') }}</v-btn>
                              <v-btn small class="error" :disabled="level.dialogValues.form_disabled || row.ctc_pk_invoicing==null" rounded @click="load_for_update(row.ctc_pk_invoicing)">{{ $t('buttons.modify') }}</v-btn>
                              <v-btn small class="error" :disabled="level.dialogValues.form_disabled || row.ctc_pk_invoicing==null" rounded @click="load_for_delete(row.ctc_pk_invoicing)">{{ $t('buttons.delete') }}</v-btn>
                           </v-col>
                        </v-row>
                        <v-row dense>
                           <v-col cols="6" sm="6">
                              <ddoSelect2
                                 :callbacks="CTCcallbacks_shipping"
                                 :key="CTCoptions_shipping.key"
                                 :options="CTCoptions_shipping"
                                 :disabled="level.dialogValues.form_disabled" 
                                 ref="mySelectCTCshipping"
                              >
                                 <template v-slot:selection="data">
                                    <v-chip
                                       v-bind="data.attrs"
                                       :input-value="data.selected"
                                       close
                                       @click:close="$refs.mySelectCTCshipping.remove(data.item)"
                                    >
                                       <span>{{data.item.ctc_email}} ({{data.item.ctc_firstname}} {{data.item.ctc_lastname}})</span>
                                    </v-chip>
                                 </template>

                                 <template v-slot:item="data">
                                    <v-list-item-content>
                                       <v-list-item-title>{{data.item.ctc_email}} ({{data.item.ctc_firstname}} {{data.item.ctc_lastname}})</v-list-item-title>
                                    </v-list-item-content>
                                 </template>
                              </ddoSelect2>
                           </v-col>
                           <v-col cols="6" sm="6">
                              <v-btn small class="error" :disabled="level.dialogValues.form_disabled || row.ctc_pk_shipping==null" rounded @click="load_for_select(row.ctc_pk_shipping)">{{ $t('buttons.display') }}</v-btn>
                              <v-btn small class="error" :disabled="level.dialogValues.form_disabled || row.ctc_pk_shipping==null" rounded @click="load_for_update(row.ctc_pk_shipping)">{{ $t('buttons.modify') }}</v-btn>
                              <v-btn small class="error" :disabled="level.dialogValues.form_disabled || row.ctc_pk_shipping==null" rounded @click="load_for_delete(row.ctc_pk_shipping)">{{ $t('buttons.delete') }}</v-btn>
                           </v-col>
                        </v-row>
                     </template>

                     <v-row dense>
                        <v-col v-if="!level.dialogValues.form_create" cols="12">
                           <b-badge class="m-1" variant="info">{{ $t('headers.created_on') }}</b-badge>{{ $api._d(row.cus_create,'long') }}<br/>
                           <b-badge class="m-1" variant="info">{{ $t('headers.updated_on') }}</b-badge>{{ $api._d(row.cus_update,'long') }}
                        </v-col>
                     </v-row>

                  </v-container>
                  </v-form>

                  <small>*{{ $t('texts.requiredfield') }}</small>
               </v-card-text>

               <CardUpdatableFooter :row="row" :level="level"/>

                  <v-dialog v-model="levels[0].dialogValues.dialogShow" max-width="700">
                     <CardUpdatableContact
                        :row="levels[0].row"
                        :level="levels[0]"
                        :childKey="row.cus_pk"
                        name="Contact"
                        data-app="true"
                        persistent
                        @change_dialogValues="change_dialogValues"
                     />
                  </v-dialog>

            </b-tab>

            <b-tab id="chapter2">
            
               <template slot="title">
                  <big><i class="icon-list"></i> {{ $t('titles.prices') }}</big>
               </template>

               <template>
                  <!--<hot-table ref="myHotTable" :settings="gridSettings" licenseKey='non-commercial-and-evaluation' width="100%" height="300"></hot-table>-->
                  <!--<vue-excel-editor ref="grid" v-model="jsonData">
                  </vue-excel-editor>-->
               </template>

            </b-tab>

         </b-tabs>
      </v-card>

    </v-dialog>

   </v-app>

</template>

<script>
import Vue from 'vue';
import i18n from '@/plugins/i18n.js';
import ddoAlert from '@/components/ddoAlert.vue';
import CardUpdatable from '@/components/partials/CardUpdatable.vue';
import CardUpdatableHeader from '@/components/partials/CardUpdatableHeader.vue';
import CardUpdatableFooter from '@/components/partials/CardUpdatableFooter.vue';
import CardUpdatableContact from '@/components/partials/CardUpdatableContact.vue';
import ddoSelect2 from '@/components/ddoSelect2.vue';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
//import { HotTable } from '@handsontable/vue';
//import { registerPlugin, copyPaste, ContextMenu } from 'handsontable/plugins';
//import 'handsontable/dist/handsontable.full.css';
//import VueExcelEditor from 'vue-excel-editor';

//Vue.use(VueExcelEditor);

export default {
   name: 'CardUpdatableCustomerreseller',
   extends: CardUpdatable,
   components: {
      ddoAlert,
      CardUpdatableHeader,
      CardUpdatableFooter,
      CardUpdatableContact,
      ddoSelect2,
      VuePhoneNumberInput,
//      VueExcelEditor,
//      HotTable, 
//      registerPlugin, ContextMenu, copyPaste,
   },

   props: {
   },

   data: function () {
      return {
         show: false,
         contactShow: false,
         boolFormValid: false,

         jsonData: [
               ['', 'Tesla', 'Mercedes', 'Toyota', 'Volvo'],
               ['2019', 10, 11, 12, 13],
               ['2020', 20, 11, 14, 13],
               ['2021', 30, 15, 12, 13]
         ],

         gridSettings: {
            data:
            [
               ['', 'Tesla', 'Mercedes', 'Toyota', 'Volvo'],
               ['2019', 10, 11, 12, 13],
               ['2020', 20, 11, 14, 13],
               ['2021', 30, 15, 12, 13]
            ],
            rowHeaders: true,
            colHeaders: true,
            contextMenu: true,
            licenseKey: 'non-commercial-and-evaluation',
         },

         cus_code_overwritten: false,
         cus_code_proposals: [],
         cus_code_readonly: true,
         cus_code_min_length: false,

         reseller_is_available: false,

         translations: {},

         warnings: [],

         levels: [
            {
               api_code: 'contact',
               api_prefix: 'ctc',
               row: { cus_pk: null, ctt_pk: null, ctc_phones: null },
               level: 0,
               errors: [],
               callbacks: {
               },
               dialogOptions: {
                  codeRules : [
                     (v) => !!v || i18n.t('texts._required')
                  ],
                  emailRules : [
                     (v) => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,24})+$/.test(v) || i18n.t('texts._email_format'),
                  ],
                  BMNameRules: [
                     (v) => !v || /^[^0-9!<>,;?=+()@#"°{}_$%:]*$/.test(v) || i18n.t('texts._bm_name_format'),
                  ]
               },
               dialogValues: {
                  headers: {
                     select: i18n.t('texts.ctc_select_title'),
                     create: i18n.t('texts.ctc_create_title'),
                     update: i18n.t('texts.ctc_update_title'),
                     delete: i18n.t('texts.ctc_delete_title'),
                  },
                  texts: {
                     create_item: i18n.t('texts.ctc_create_item'),
                  },
                  dialogShow: false,
                  form_disabled: false,
                  form_close: true,
                  form_create: false,
                  form_update: false,
                  form_delete: false,
                  disable_create: false,
                  disable_update: false,
                  disable_delete: false,
                  readonly: false,
                  header_value_function: function(row) { return row['ctc_email']; }
               },
            },
         ],

         selectedCTC: {},

         CTTcallbacks: {},
         CTToptions: {
            initial: null,
            selected: null,
            required: true,
            disabled: false,
            multiple: false,
            clearable: false,
            item_text: "ctt_name",
            item_value: "ctt_pk",
            item_disabled: "",
            hide_selected: false,
            change_on_remove: true,
            label: i18n.t('texts.ctt_name'),
         },

         CUTcallbacks: {},
         CUToptions: {
            key: "CUTselect",
            initial: null,
            selected: null,
            required: true,
            disabled: false,
            multiple: false,
            clearable: false,
            item_text: "cut_name",
            item_value: "cut_pk",
            item_disabled: "",
            hide_selected: false,
            change_on_remove: true,
            triggers_refresh: false,
            label: i18n.t('texts.cut_name'),
         },

         CUSREScallbacks: {},
         CUSRESoptions: {
            key: "CUSRESselect",
            initial: null,
            selected: null,
            required: true,
            disabled: false,
            multiple: false,
            clearable: false,
            item_text: "cus_name",
            item_value: "cus_pk",
            item_disabled: "",
            hide_selected: false,
            change_on_remove: true,
            triggers_refresh: false,
            label: i18n.t('texts.cus_name_reseller'),
         },

         CTCcallbacks_general: {},
         CTCcallbacks_invoicing: {},
         CTCcallbacks_shipping: {},
         CTCoptions_general: {
            key: "CTC_general",
            initial: null,
            selected: null,
            required: true,
            disabled: false,
            multiple: false,
            clearable: false,
            item_text: "ctc_email",
            item_value: "ctc_pk",
            item_disabled: "",
            hide_selected: false,
            change_on_remove: true,
            triggers_refresh: false,
            label: i18n.t('texts.ctc_name_general'),
         },
         CTCoptions_invoicing: {
            key: "CTC_invoicing",
            initial: null,
            selected: null,
            required: true,
            disabled: false,
            multiple: false,
            clearable: false,
            item_text: "ctc_email",
            item_value: "ctc_pk",
            item_disabled: "",
            hide_selected: false,
            change_on_remove: true,
            label: i18n.t('texts.ctc_name_invoicing'),
         },
         CTCoptions_shipping: {
            key: "CTC_shipping",
            initial: null,
            selected: null,
            required: true,
            disabled: false,
            multiple: false,
            clearable: false,
            item_text: "ctc_email",
            item_value: "ctc_pk",
            item_disabled: "",
            hide_selected: false,
            change_on_remove: true,
            label: i18n.t('texts.ctc_name_shipping'),
         },
      }
   },

   created() {

      //registerPlugin(ContextMenu);
      //registerPlugin(copyPaste);
      //registerPlugin(nestedHeaders);

      this.translations = {
         countrySelectorLabel: i18n.t('texts.countrySelectorLabel'),
         countrySelectorError: i18n.t('texts.countrySelectorError'),
         example: i18n.t('texts.example'),
      }

      this.CTTcallbacks.refresh_rows     = this.build_select_ctt;
      this.CTTcallbacks.change           = this.change_ctt;

      this.CUTcallbacks.refresh_rows     = this.build_select_cut;
      this.CUTcallbacks.change           = this.change_cut;

      this.CUSREScallbacks.refresh_rows     = this.build_select_cusres;
      this.CUSREScallbacks.change           = this.change_cusres;

      this.CTCcallbacks_general.refresh_rows   = this.build_select_ctc;
      this.CTCcallbacks_invoicing.refresh_rows = this.build_select_ctc;
      this.CTCcallbacks_shipping.refresh_rows  = this.build_select_ctc;

      this.CTCcallbacks_general.change   = this.change_ctc_general;
      this.CTCcallbacks_invoicing.change = this.change_ctc_invoicing;
      this.CTCcallbacks_shipping.change  = this.change_ctc_shipping;

      /*
       * DO NOT CONFUSE :
       * - this.level points to props 'level', from upper level (CustomerResellers.vue)
       * - this.levels[0] points to local array, to lower Vue (CardUpdatableContact.vue)
       */
      this.levels[0].callbacks.configure_form = this.configure_form;
      this.levels[0].callbacks.prepare_create = this.prepare_create;    
      this.levels[0].callbacks.prepare_update = this.prepare_update;    
      this.levels[0].callbacks.prepare_delete = this.prepare_delete;    
      this.levels[0].callbacks.show_dialog    = this.show_dialog;

      this.levels[0].callbacks.after_create_row = this.after_create_row;    
      this.levels[0].callbacks.after_update_row = this.after_update_row;    
      this.levels[0].callbacks.after_delete_row = this.after_delete_row;    
   },

   mounted() {
      console.log('mounted, level.dialogValues='+JSON.stringify(this.level.dialogValues))
   },

   watch: {
      row: 'loadOtherInformations',
   },

   computed: {

      isFormValid: {
         get: function() {
            return this.boolFormValid;
         },
         set: function(newValue) {
            console.log('isFormValid, newValue='+newValue)
            this.boolFormValid = newValue;
            if ( this.level.dialogValues.form_create==true ) {
               this.$emit('change_dialogValues',this.level.level,'disable_create',!newValue);
            }
            if ( this.level.dialogValues.form_update==true ) {
               this.$emit('change_dialogValues',this.level.level,'disable_update',!newValue);
            }
         }
      },

      get_hint_by_situation: function() {
         if ( level.dialogValues.form_create ) {
            return i18.t('hints.cus_code_create');
         } else {
            return i18.t('hints.cus_code_update');
         }
      }
   },

   methods: {

      v_icon_code(flag) {
         return ( flag==true ? "mdi-pencil-box-outline" : "mdi-pencil-box" )
      },

      change_edit() {
         this.cus_code_readonly = !this.cus_code_readonly;
      },

      only_ASCII(e) {
         let char = String.fromCharCode(e.keyCode); // Get the character
         if ( /^[A-Za-z0-9\-]+$/.test(char) ) return true; // Match with regex 
         else e.preventDefault(); // If not match, don't add to input text
      },

      uppercase_cus_code() {
         this.row.cus_code = this.row.cus_code.toUpperCase();
      },

      async check_code(value) {
         if ( this.level.dialogValues.form_create ) {
            var parameters = { cus_name: value };
            var { errorinfos, api_response } = await this.$api.getRows(this.$router,'customer/checkcodebyname',parameters);
            if ( api_response.error==0 ) {
               if ( !this.cus_code_overwritten ) {
                  if ( api_response.rows && api_response.rows.proposals ) {
                     this.row.cus_code = this.first_valid_proposal(api_response.rows.proposals);
                  }
               }
               this.cus_code_min_length = ( this.row.cus_code.length>=3 ? true : false );
               this.row.cus_desc = this.row.cus_code;
            }
         }
      },

      loadOtherInformations(row,oldRow) {
         this.refresh_dropdowns(row);
         this.refresh_prices(row);
         this.change_cut(row.cut_pk);
         this.reseller_is_available = (row.cut_is_reseller!=true ? true : false );
      },

      /*
       * By changing the key of each 'ddoSelect2', key pointing to XXX.options.key,
       * we trigger a change/refresh in each component.
       * And by this way, we trigger a 'refresh_rows'.
       * Inspired from : https://michaelnthiessen.com/force-re-render/
       */
      refresh_dropdowns(row) {
         this.CTCoptions_general.key = 'CTC_general_'+row.cus_pk;
         this.CTCoptions_invoicing.key = 'CTC_invoicing_'+row.cus_pk;
         this.CTCoptions_shipping.key = 'CTC_shipping_'+row.cus_pk;
      },

      async refresh_prices(row) {
         this.loading = true;
         let { errorinfos, api_response } = await this.$api.getRows(this.$router,'customer/'+row.cus_pk+'/prices');
         this.loading = false;
         //console.log('refresh_prices, api_response='+JSON.stringify(api_response));
         console.log('refresh_prices, api_response='+JSON.stringify(this.gridSettings.data));
         return { errorinfos, api_response }
      },

      phone_update_fixed(data) {
         console.log('phone_update_fixed, data='+JSON.stringify(data))
         if ( data.isValid ) {
            this.row.ctc_phone_fixed_phone = data.formattedNumber;
         }
      },

      phone_update_cell(data) {
         console.log('phone_update_cell, data='+JSON.stringify(data))
         if ( data.isValid ) {
            this.row.ctc_phone_cell_phone = data.formattedNumber;
         }
      },

      async build_select_ctt(key=null) {
         this.loading = true;
         let { errorinfos, api_response } = await this.$api.getRows(this.$router,'contacttitle');
         this.loading = false;
         console.log('build_select_ctt, data='+JSON.stringify(api_response))
         return { errorinfos, api_response }
      },

      change_ctt(value,item=null) {
         console.log('change_ctt, value='+value)
         this.row.ctt_pk = value;
      },

      change_cut(value,item=null) {
         console.log('change_cut, value='+value);
         if (value==null) {
            this.row.cut_pk = null;
            this.row.cus_invoice_default_reseller = false;
            this.reseller_is_available = false;
         } else {
            if ( this.$refs.mySelectCUT!=null) {
               let cut_record = this.$api._get_by_pk(this.$refs.mySelectCUT.items,value);
               if ( cut_record.cut_is_reseller==true) {
                  this.reseller_is_available = false;
                  this.row.cut_pk_customer = null;
                  this.row.cus_invoice_default_reseller = false;
               } else {
                  this.reseller_is_available = true;
               }
            }
         }
         //console.log('change_cut, items='+JSON.stringify(this.$refs.mySelectCUT.items));
         this.row.cut_pk = value;
      },

      async build_select_cut(key=null) {
         this.loading = true;
         let cus_value = null;
         if ( this.level.session_row ) {
            cus_value = this.level.session_row.cus_pk;
         }
         let { errorinfos, api_response } = await this.$api.getRows(this.$router,'customer/'+cus_value+'/customertypes');
         this.loading = false;
         return { errorinfos, api_response }
      },

      adapt_cut_on_create() {
         let cut_pk = this.$api._get_pk_by_value(this.$refs.mySelectCUT.items,'NORM','cut_code');
         console.log('adapt_cut_on_create, form_create, cut_pk='+cut_pk)
         if ( cut_pk!=null ) {
            this.CUToptions.selected = cut_pk;
         }
      },

      async build_select_cusres(key=null) {
         this.loading = true;
         let { errorinfos, api_response } = await this.$api.getRows(this.$router,'customer/resellers');
         this.loading = false;
         return { errorinfos, api_response }
      },

      change_cusres(value,item=null) {
         console.log('change_cusres, value='+value)
         this.row.cus_pk_customer = value;
      },

      async build_select_ctc(key=null) {
         this.loading = true;
         let { errorinfos, api_response } = await this.$api.getRows(this.$router,'customer/'+this.row.cus_pk+'/contacts');
         this.loading = false;
         return { errorinfos, api_response }
      },

      async change_ctc_general(value,item=null) {
         this.level.row.ctc_pk_general = value;
      },

      async change_ctc_invoicing(value,item=null) {
         this.level.row.ctc_pk_invoicing = value;
      },

      async change_ctc_shipping(value,item=null) {
         this.level.row.ctc_pk_shipping = value;
      },

      configure_form(level,f_disabled,f_create,f_update,f_delete) {
         let _dV = this.levels[level].dialogValues;
         _dV.form_disabled = f_disabled;
         _dV.form_create   = f_create;
         _dV.form_update   = f_update;
         _dV.form_delete   = f_delete;
         this.levels[level].dialogValues = _dV;
      },

      show_dialog(level,show) {
         let _dV = this.levels[level].dialogValues;
         _dV.header_value = _dV.header_value_function(this.levels[level].row);
         _dV.dialogShow   = show;
         this.levels[level].dialogValues = _dV;
      },

      async load_for_create(origin=null) {
         if ( this.levels[0].callbacks.prepare_create ) {
            await this.levels[0].callbacks.prepare_create(this.childKey,origin);
         }
         this.levels[0].callbacks.configure_form(this.levels[0].level,false,true,false,false);
         this.levels[0].callbacks.show_dialog(this.levels[0].level,true);
      },

      async load_for_select(_pk,origin=null) {
         this.$emit('loading',true);
         var { errorinfos, api_response } = await this.$api.getRow(this.$router,this.levels[0].api_code,_pk);
         this.$emit('loading',false);

         //await this.refresh_ctc_dropdowns() ;

         this.levels[0].callbacks.configure_form(this.levels[0].level,true,false,false,false);

         if ( api_response.error==0 && api_response.row ) {
            this.levels[0].row = api_response.row;
            if ( this.levels[0].callbacks.prepare_update ) {
               this.levels[0].callbacks.prepare_update(this.row.cus_pk,_pk,api_response.row,origin);
            }
            this.levels[0].callbacks.show_dialog(this.levels[0].level,true);
         } else {
            this.errors = [errorinfos];
         }
      },

      async load_for_update(_pk,origin=null) {
         console.log('load_for_update, _pk='+_pk)
         this.$emit('loading',true);
         var { errorinfos, api_response } = await this.$api.getRow(this.$router,this.levels[0].api_code,_pk);
         this.$emit('loading',false);

         //await this.refresh_ctc_dropdowns();
         
         this.levels[0].callbacks.configure_form(this.levels[0].level,false,false,true,false);

         if ( api_response.error==0 && api_response.row ) {
            this.levels[0].row = api_response.row;
            this.parse_phones(this.levels[0].row);
            if ( this.levels[0].callbacks.prepare_update ) {
               await this.levels[0].callbacks.prepare_update(this.row.cus_pk,_pk,api_response.row,origin);
            }
            this.levels[0].callbacks.show_dialog(this.levels[0].level,true);
         } else {
            this.errors = [errorinfos];
         }
      },

      async load_for_delete(_pk,origin=null) {
         this.$emit('loading',true);
         var { errorinfos, api_response } = await this.$api.getRow(this.$router,this.levels[0].api_code,_pk);
         this.$emit('loading',false);

         //await this.refresh_ctc_dropdowns() ;
         
         this.levels[0].callbacks.configure_form(this.levels[0].level,true,false,false,true);

         if ( api_response.error==0 && api_response.row ) {
            this.levels[0].row = api_response.row;
            if ( this.levels[0].callbacks.prepare_delete ) {
               this.levels[0].callbacks.prepare_delete(this.row.cus_pk,_pk,api_response.row,origin);
            }
            this.levels[0].callbacks.show_dialog(this.levels[0].level,true);
         } else {
            this.errors = [errorinfos];
         }
      },

      async prepare_create(parentKey=null) {
         console.log('prepare_create, parentKey='+parentKey)
         this.levels[0].row.cus_pk = this.row.cus_pk;
         this.levels[0].row.ctc_uuid = null;
         this.levels[0].row.ctc_bm_id = null;
         this.levels[0].row.ctc_bm_address_billing_id = null;
         this.levels[0].row.ctc_bm_address_shipping_id = null;
         this.levels[0].row.ctc_phones = { ctc_phone_fixed_phone: { nationalNumber: '' }, ctc_phone_cell_phone: { nationalNumber: '' } };

         this.levels[0].errors = [];
      },

      async prepare_update(parentKey=null) {
         console.log('prepare_update, parentKey='+parentKey)
         this.levels[0].row.cus_pk = parentKey;
         this.levels[0].row.ctc_phones = { ctc_phone_fixed_phone: { nationalNumber: '' }, ctc_phone_cell_phone: { nationalNumber: '' } };         

         this.levels[0].errors = [];
      },

      async prepare_delete(parentKey=null) {
         console.log('prepare_delete, parentKey='+parentKey)
         this.levels[0].row.cus_pk = parentKey;
         this.levels[0].row.ctc_phones = { ctc_phone_fixed_phone: { nationalNumber: '' }, ctc_phone_cell_phone: { nationalNumber: '' } };
         this.parse_phones(this.levels[0].row);

         this.levels[0].errors = [];
      },

      async refresh_ctc_dropdowns() {
         await this.$refs.mySelectCTCgeneral.refresh_rows();
         await this.$refs.mySelectCTCinvoicing.refresh_rows();
         await this.$refs.mySelectCTCshipping.refresh_rows();
      },

      async refresh_ctc_selects() {
         /*
          * Refresh the 3 dropdowns. Unfortunately, they are the same...
          */
         await this.refresh_ctc_dropdowns();
         /*
          * If the previous action was to delete a contact, we
          * have to nullify the corresponding dropdowns 'selected',
          * and nullify the associated fields in this.row
          */
         let row = {};
         row = this.$api._get_by_pk(this.$refs.mySelectCTCgeneral.items,this.$refs.mySelectCTCgeneral.options.selected);
         if ( row==null ) { this.$refs.mySelectCTCgeneral.options.selected = null; }
         row = this.$api._get_by_pk(this.$refs.mySelectCTCinvoicing.items,this.$refs.mySelectCTCinvoicing.options.selected);
         if ( row==null ) { this.$refs.mySelectCTCinvoicing.options.selected = null; }
         row = this.$api._get_by_pk(this.$refs.mySelectCTCshipping.items,this.$refs.mySelectCTCshipping.options.selected);
         if ( row==null ) { this.$refs.mySelectCTCshipping.options.selected = null; }
         this.level.row.ctc_pk_general   = this.$refs.mySelectCTCgeneral.options.selected;
         this.level.row.ctc_pk_invoicing = this.$refs.mySelectCTCinvoicing.options.selected;
         this.level.row.ctc_pk_shipping  = this.$refs.mySelectCTCshipping.options.selected;
      },

      async after_create_row(level,errorinfos,api_response) {
         if ( api_response.error==0 ) {
            await this.refresh_ctc_selects();
         } else {
            this.levels[0].errors = [errorinfos];
         }
      },

      async after_update_row(level,errorinfos,api_response) {
         if ( api_response.error==0 ) {
            await this.refresh_ctc_selects();
         } else {
            this.levels[0].errors = [errorinfos];
         }
      },

      async after_delete_row(level,errorinfos,api_response) {
         if ( api_response.error==0 ) {
            await this.refresh_ctc_selects();
         } else {
            this.levels[0].errors = [errorinfos];
         }
      },

      first_valid_proposal(proposals) {
         var ret = '';
         for( var i=0;i<proposals.length;i++ ) {
            if ( proposals[i].available && proposals[i].available==true ) {
               ret =  proposals[i].cus_code;
               break;
            }
         }
         console.log('first_valid_proposal, ret='+ret)
         return ret;
      },

      parse_phones(row) {
         /*
          * We recreate the 'phones' objet, in current 'row'
          */
         row.ctc_phones = { ctc_phone_fixed_phone: { country: "FR" }, ctc_phone_cell_phone: { country: "FR" } };
         /*
          * And re-scan phones : ctc_phone_fixed_phone, ...
          */
         if ( row.ctc_phone_fixed_phone!=null ) {
            let parse = parsePhoneNumberFromString(row.ctc_phone_fixed_phone);
            if ( parse ) {
               row.ctc_phones.ctc_phone_fixed_phone = parse;
            }
         }
         if ( row.ctc_phone_cell_phone!=null ) {
            let parse = parsePhoneNumberFromString(row.ctc_phone_cell_phone);
            if ( parse ) {
               row.ctc_phones.ctc_phone_cell_phone = parse;
            }
         }
      },

      change_dialogValues(level,property,value) {
         console.log('change_dialogValues, level='+level+', property='+property+', value='+value)
         this.levels[level].dialogValues[property] = value;
      },

   },

}
</script>